<template>
    <div class="">
        <dash-header></dash-header>
        <div class="dash-backer">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import DashHeader from './header/DashHeader.vue'
//import CompetitionAdmin from './competition/CompetitionAdmin.vue'
//import AddNewComp from './competition/AddNewComp.vue'

export default {
    name: 'Dash',
    components: {
        DashHeader
    }, 
    computed: {
        /*
        competitions() {
            return this.$store.getters['backend/competitions']
        },
        */
    },
    methods:{

    }
}
</script>

<style>
.dash-backer { 
    background-color: #f5f5f5; 
    padding: 0 1.5rem; min-height: calc(100vh - 4rem); 
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>
